import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const restoreDeletedTask = api(async function restoreDeletedTask({ projectId, scheduleId, taskId }) {
    return mutate(
        gql`
            mutation RestoreDeletedTask($projectId: String!, $scheduleId: String!, $taskId: String!) {
                restoreDeletedTask(projectId: $projectId, scheduleId: $scheduleId, taskId: $taskId)
            }
        `,
        {
            projectId,
            scheduleId,
            taskId,
        },
        { returns: "restoreDeletedTask" }
    )
})
